export const SUBSCRIBE_TEXT = 'Are you sure you want to subscribe the Network element?';
export const SUBSCRIBE_SFTP_TEXT = `Are you sure you want to subscribe to all netconf notifications?`;
export const UNSUBSCRIBE_SFTP_TEXT = `Are you sure you want to unsubscribe from all netconf notifications?`;
export const SUBSCRIBE_SFTP_SUBTEXT = `It means that direct SFTP PM data retrieval will be automatically disabled.`;
export const SUBSCRIBE_SFTP_AUTOSWITCH_SUBTEXT = `
	It means that direct SFTP PM data retrieval and auto switch option will be automatically disabled.
`;

export const UNSUBSCRIBE_TEXT = 'Are you sure you want to unsubscribe the Network element?';
export const CONNECT_TEXT = 'Are you sure you want to connect the Network element?';
export const DISCONNECT_TEXT = 'Are you sure you want to disconnect the Network element?';
export const DELETE_TEXT = 'Are you sure you want to delete the Network element?';
export const DISABLE_SFTP_TEXT = 'Are you sure you want to disable direct SFTP PM data retrieval?';
export const DISABLE_AUTOSWITCH_TEXT = 'Are you sure you want to disable auto switch?';
export const AUTOSWITCH_DISABLE_SFTP_SUBTEXT = `Auto switch option will be automatically disabled.`;
export const NOT_SUPPORTED_FOR_BENETEL_RUS = 'Not supported for Benetel RUs';

export const AUTOSWITCH_TIME_INTERVAL_LABEL = 'Time interval counted from the last VES event to trigger a switch to Direct SFTP PM data retrieval';
export const NETCONF_CHECK_PERIOD_LABEL = 'Time period after which it is checked whether VES netconf notifications are working';

export const TABS_HEIGHT = 'calc(100% - 50px)';

export const DEFAULT_SFTP_PATH = '/var/data/O-RAN/';
export const NETWORK_ELEMENT_TYPES = {
	CU: 'CU',
	DU: 'DU',
	RU: 'RU',
	CUDU: 'CUDU',
};

export const NETWORK_ELEMENTS_TABS_NAMES = {
	networkElements: 'Network Elements',
	connectionStatusLog: 'Connection Status Log',
};

export const IP_ADDRESS_TOOLTIP = `
	1) Valid IP address is in the form “x.x.x.x”,
		where each x is a number in the range 0 <= x <= 255,
		does not have leading zeros, and is separated by a dot
	2) IP address must be unique
`;
